<template>
  <UiModal modal-styles="mobile-bottom tablet-bottom" @close="onClose">
    <div class="complain-body" @click.stop>
      <h3 class="text-h3-bold-up">Расскажите, в чём дело</h3>

      <div class="checkboxes">
        <ui-p-checkbox
          v-for="(reason, index) in reasons"
          :key="index"
          :value="reason.selected"
          :label="reason.text"
          @change="reason.selected = !reason.selected"
        />
      </div>

      <UiPTextarea
        ref="otherRef"
        v-model:value="reasonText"
        :auto-height="true"
        height="146px"
        name="reason_text"
        class="reason__text"
        max-length="2000"
        placeholder="Опишите проблему"
      >
        <template #right>
          <ui-char-counter :max="2000" :value="reasonText" />
        </template>
      </UiPTextarea>
      <div class="controls">
        <ui-ui-button
          :resize="true"
          :type="submitEnabled ? 'primary' : 'neutral'"
          :disabled="!submitEnabled"
          @click="onSubmit"
        >
          Отправить
        </ui-ui-button>
      </div>
    </div>
  </UiModal>
</template>

<script setup lang="ts">
import { API } from '~/api/api';

interface reasonItem {
  text: string;
  selected: boolean;
}

const props = defineProps({
  offerId: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['close']);

const onClose = () => {
  emit('close');
};

const reasonText = ref<string>('');
const otherRef = ref();
const otherText = 'Другое';
const reasons = ref<reasonItem[]>([
  { text: 'Неверная цена', selected: false },
  { text: 'Нет в наличии', selected: false },
  { text: 'Неверная категория или модель', selected: false },
  { text: 'Неверные срок/стоимость доставки', selected: false },
  { text: 'Продажа поддельной продукции', selected: false },
  { text: 'Подозрение в мошенничестве', selected: false },
  { text: otherText, selected: false },
]);

const submitEnabled = computed(
  () =>
    reasons.value.filter((v) => v.text !== otherText).some((v) => v.selected) ||
    (reasons.value.some((v) => v.text === otherText) && reasonText.value)
);

const onSubmit = async () => {
  const reason = reasons.value
    .filter((v) => v.selected)
    .map((v) => v.text)
    .join(', ');

  const data = {
    offer_id: props.offerId,
    reason,
    text: reasonText.value,
  };
  await API.post('/user-content/complaints/create', data).catch((e) =>
    console.error('post complaints create error', e)
  );
  emit('close', 'success');
};

watch(
  () => reasons.value.find((v) => v.text === otherText).selected,
  (v) => {
    if (v) {
      nextTick(() => {
        otherRef.value.textareaRef.focus();
      });
    }
  }
);
</script>
<style lang="scss" src="./complain-modal.scss" scoped />
